<button appTooltip="Select Feature" [ngClass]="{'esk-tool--active' : active()===true}" class="esk-tool" (click)="active.set(!active())" ><i class="fa fa-mouse-pointer"></i></button>
<ng-content></ng-content>
